import React from 'react'
import classNames from 'classnames'

import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'

export interface Props {
  text?: React.ReactNode
  color?: 'royal' | 'nile'
  className?: string
}

const Config = {
  sideBorderWidth: 12.5,
  royalBlue: '#3D7CFF',
  royalBlueDarken: '#2865E4',
  nileBlue: '#27354F',
  nileBlueDarken: '#202D44',
}

const styles = createStyles({
  root: {
    zIndex: 1,
    position: 'relative',
    padding: `0 ${Config.sideBorderWidth * 2}px`,
  },
  side: {
    border: `${Config.sideBorderWidth}px solid transparent`,
    position: 'absolute',
    display: 'inline-block',
    width: 0,
    height: 0,
    borderTopStyle: 'solid',
    borderTopWidth: Config.sideBorderWidth,
    borderBottomStyle: 'solid',
    borderBottomWidth: Config.sideBorderWidth,
    bottom: -3,
    zIndex: -1,
  },
  text: {
    color: 'white',
    lineHeight: 2.4,
    letterSpacing: 2,
    textTransform: 'uppercase',
  },
  leftSide: {
    left: 4,
    borderRightStyle: 'solid',
    borderRightWidth: Config.sideBorderWidth,
  },
  'leftSide-royal': {
    borderTopColor: Config.royalBlueDarken,
    borderBottomColor: Config.royalBlueDarken,
    borderRightColor: Config.royalBlueDarken,
  },
  'leftSide-nile': {
    borderTopColor: Config.nileBlueDarken,
    borderBottomColor: Config.nileBlueDarken,
    borderRightColor: Config.nileBlueDarken,
  },
  rightSide: {
    right: 4,
    borderLeftStyle: 'solid',
    borderLeftWidth: Config.sideBorderWidth,
  },
  'rightSide-royal': {
    borderTopColor: Config.royalBlueDarken,
    borderBottomColor: Config.royalBlueDarken,
    borderLeftColor: Config.royalBlueDarken,
  },
  'rightSide-nile': {
    borderTopColor: Config.nileBlueDarken,
    borderBottomColor: Config.nileBlueDarken,
    borderLeftColor: Config.nileBlueDarken,
  },
  textContainer: {
    height: 25,
    padding: '0 18px',
    position: 'relative',
    overflow: 'hidden',
  },
  'textContainer-royal': {
    backgroundColor: Config.royalBlue,
  },
  'textContainer-nile': {
    backgroundColor: Config.nileBlue,
  }
})

type InjectedProps = Props & WithStyles

const Ribbon: React.SFC<InjectedProps> = ({ text, color, classes, className }) => {
  return (
    <div className={classNames(classes.root, className)}>
      <div className={classNames(classes.side, classes.leftSide, classes[`leftSide-${color}`])} />
      <div className={classNames(classes.textContainer, classes[`textContainer-${color}`])}>
        <Typography className={classes.text} variant="caption" children={text} noWrap />
      </div>
      <div className={classNames(classes.side, classes.rightSide, classes[`rightSide-${color}`])} />
    </div>
  )
}

Ribbon.defaultProps = {
  color: 'royal',
}

export default withStyles(styles)(Ribbon)
